export const USER_TYPE_ADMIN = 0;
export const USER_TYPE_MC_ADMIN = 1;
export const USER_TYPE_EMPLOYEE = 2;
export const USER_TYPE_CLIENT = 3;
export const USER_TYPE_HOUSE_IMPORTER = 4;
